import moment, { Moment } from 'moment';
import axios from 'axios';

import {
  CLEAR_FORM,
  CLEAR_TIMETABLE,
  CREATE_SPECIAL_EVENT,
  GET_DELIVERY_HOURS,
  GET_MASS_UPLOAD_FILE,
  GET_SPECIAL_EVENT_REASONS,
  SET_12H_FORMAT,
  SET_CLOSE_TO_ALL,
  SET_IS_LOADING,
  SET_OPEN_24HOURS_TO_ALL,
  SET_SELECTED_RANGE_DATE,
  SET_SELECTED_START_DATE,
  SET_SPECIAL_EVENT_DATA,
  SET_SPECIFIC_SPECIAL_EVENT_DATA,
  SHOW_HOLIDAYS,
  TOGGLE_12H_FORMAT,
  HEALTH_CHECK_MDS,
  GET_SINGLE_RESTAURANT_WEEK_HOURS,
  GET_SPECIAL_EVENT_DAY_BY_DAY,
  TOGGLE_OPERATION_HOURS_VIEW_MODE,
  SET_RECENTLY_EDITED_BASE_HOURS,
  CLEAR_RECENTLY_EDITED_BASE_HOURS,
} from '../action-types/new-operation-hours-types';
import { axiosAction } from '../../utils/axiosAction';
import { formatYYYYMMDD, getHourCycle } from '../../utils/utils';
import { times } from '../../redux/reducers/newOperationHoursReducer';
import { snackbarShowMessage } from './snackbarActions';
import i18next from 'i18next';
import { useValidationHoursAndEmitMessage } from '../../hooks/useValidateHoursAndEmitMessage';
import { RecentlyEditedBaseHours } from '../../components/OperationHoursViewTab/hooks/useServiceData';

export const toggle12HFormat = () => async (dispatch, getState) => {
  dispatch({ type: TOGGLE_12H_FORMAT });
};

export const set12HFormat =
  ({ H12Format }) =>
  async (dispatch, getState) => {
    dispatch({ type: SET_12H_FORMAT, payload: H12Format });
  };

export const createSpecialEvent =
  ({ translation, isNotPLKLockedDayparts, hasDeliveryPermission }) =>
  async (dispatch, getState) => {
    const { RestaurantId, Region } = getState().RestaurantsReducer.entity;
    const brand = getState().UIReducer.selectedBrand;
    const restaurantServices = getState().ServicesReducer.entities;
    const curbsideService = restaurantServices.find(
      elem => elem.code === 'curbsidePickup',
    );
    const cateringService = restaurantServices.find(
      elem => elem.code === 'catering',
    );
    const driveThruService = restaurantServices.find(
      elem => elem.code === 'driveThru',
    );
    const digitalDriveThruService = restaurantServices.find(
      elem => elem.code === 'digitalDriveThru',
    );

    const {
      selectedStartDate,
      selectedEndDate,
      specialEventReason,

      // Request Params
      id,
      specialEventArrival,
      specialEventDeparture,

      drIsOpened24Hours,
      drIsClosed,
      drTimeOpen,
      drTimeClose,

      dtIsOpened24Hours,
      dtIsClosed,
      dtTimeOpen,
      dtTimeClose,

      digitalDtIsOpened24Hours,
      digitalDtIsClosed,
      digitalDtTimeOpen,
      digitalDtTimeClose,

      isCalculated,
      deliveryTimeOpen,
      deliveryTimeClose,
      dhIsClosed,

      curbsideTimeOpen,
      curbsideTimeClose,
      curbsideIsClosed,

      cateringTimeOpen,
      cateringTimeClose,
      cateringIsClosed,
      closeToAll,
    } = getState().NewOperationHoursReducer;
    const endpoint = `${process.env.REACT_APP_ENDPOINT_SPECIAL_EVENT}/${
      RestaurantId ? RestaurantId : 'massUpload'
    }`;
    const requestBody: any = {};
    if (id) {
      requestBody.id = parseInt(id);
    }

    if (selectedStartDate) {
      requestBody.specialEventDateStart =
        selectedStartDate.format(formatYYYYMMDD);
    }

    if (selectedEndDate) {
      requestBody.specialEventDateEnd = selectedEndDate.format(formatYYYYMMDD);
    } else {
      requestBody.specialEventDateEnd = requestBody.specialEventDateStart;
    }

    if (isCalculated === 'Y' || isCalculated === 'N') {
      requestBody.isCalculated = isCalculated;
    }

    if (specialEventArrival) {
      requestBody.specialEventArrival = specialEventArrival;
    } else {
      requestBody.specialEventArrival = null;
    }

    if (specialEventReason) {
      requestBody.specialEventReason = parseInt(specialEventReason);
    }

    if (specialEventDeparture) {
      requestBody.specialEventDeparture = specialEventDeparture;
    } else if (
      !specialEventDeparture &&
      brand === 'TH' &&
      (Region === 'NA' || !RestaurantId)
    ) {
      requestBody.specialEventDeparture = null;
    }
    if (driveThruService && driveThruService.value) {
      if (dtIsOpened24Hours === 'Y') {
        requestBody.dtIsOpened24Hours = 'Y';
        requestBody.dtIsClosed = 'N';
        if (!RestaurantId) {
          requestBody.dtTimeOpen = '00:00';
          requestBody.dtTimeClose = '23:59';
        }
      } else {
        if (dtIsClosed === 'Y') {
          requestBody.dtIsOpened24Hours = 'N';
          requestBody.dtIsClosed = 'Y';
          if (!RestaurantId) {
            requestBody.dtTimeOpen = '';
            requestBody.dtTimeClose = '';
          }
        } else {
          requestBody.dtIsOpened24Hours = 'N';
          requestBody.dtIsClosed = 'N';

          if (dtTimeOpen) {
            requestBody.dtTimeOpen = dtTimeOpen;
          }
          if (dtTimeClose) {
            requestBody.dtTimeClose = dtTimeClose;
          }
        }
      }
    } else {
      requestBody.dtIsOpened24Hours = 'N';
      requestBody.dtIsClosed = 'Y';
    }

    if (digitalDriveThruService && digitalDriveThruService.value) {
      if (digitalDtIsOpened24Hours === 'Y') {
        requestBody.digitalDtIsOpened24Hours = 'Y';
        requestBody.digitalDtIsClosed = 'N';
        if (!RestaurantId) {
          requestBody.digitalDtTimeOpen = '00:00';
          requestBody.digitalDtTimeClose = '23:59';
        }
      } else {
        if (digitalDtIsClosed === 'Y') {
          requestBody.digitalDtIsOpened24Hours = 'N';
          requestBody.digitalDtIsClosed = 'Y';
          if (!RestaurantId) {
            requestBody.digitalDtTimeOpen = '';
            requestBody.digitalDtTimeClose = '';
          }
        } else {
          requestBody.digitalDtIsOpened24Hours = 'N';
          requestBody.digitalDtIsClosed = 'N';

          if (digitalDtTimeOpen) {
            requestBody.digitalDtTimeOpen = digitalDtTimeOpen;
          }
          if (digitalDtTimeClose) {
            requestBody.digitalDtTimeClose = digitalDtTimeClose;
          }
        }
      }
    } else {
      requestBody.digitalDtIsOpened24Hours = 'N';
      requestBody.digitalDtIsClosed = 'Y';
    }

    if (drIsOpened24Hours === 'Y') {
      requestBody.drIsOpened24Hours = 'Y';
      requestBody.drIsClosed = 'N';
      if (!RestaurantId) {
        requestBody.drTimeOpen = '00:00';
        requestBody.drTimeClose = '23:59';
      }
    } else {
      if (drIsClosed === 'Y') {
        requestBody.drIsOpened24Hours = 'N';
        requestBody.drIsClosed = 'Y';
        if (!RestaurantId) {
          requestBody.drTimeOpen = '';
          requestBody.drTimeClose = '';
        }
      } else {
        requestBody.drIsOpened24Hours = 'N';
        requestBody.drIsClosed = 'N';

        if (drTimeOpen) {
          requestBody.drTimeOpen = drTimeOpen;
        }
        if (drTimeClose) {
          requestBody.drTimeClose = drTimeClose;
        }
      }
    }
    if (cateringService && cateringService.value) {
      if (cateringIsClosed === 'Y') {
        if (!RestaurantId) {
          requestBody.cateringTimeOpen = '';
          requestBody.cateringTimeClose = '';
        }
        delete requestBody.cateringIsClosed;
      } else {
        if (cateringTimeOpen && cateringTimeClose) {
          requestBody.cateringTimeOpen = cateringTimeOpen;
          requestBody.cateringTimeClose = cateringTimeClose;
          delete requestBody.cateringIsClosed;
        } else if (
          RestaurantId &&
          ((!closeToAll && brand === 'TH') || brand !== 'TH') &&
          isNotPLKLockedDayparts
        ) {
          dispatch(
            snackbarShowMessage(i18next.t('operationHours.cateringMandatory')),
          );
          return;
        }
      }
    }

    try {
      Object.assign(requestBody, getHourOfOperationOverrides());
      delete requestBody.cateringIsClosed;
      delete requestBody.curbsideIsClosed;
    } catch (e) {
      dispatch(snackbarShowMessage(e.message));
      return;
    }

    function getHourOfOperationOverrides() {
      return {
        dhIsClosed: getDhIsClosed(),
        deliveryTimeClose: getDeliveryTimeClose(),
        deliveryTimeOpen: getDeliveryTimeOpen(),
        curbsideTimeOpen: getCurbsideOpen(),
        curbsideTimeClose: getCurbsideClose(),
        cateringTimeOpen: getCateringOpen(),
        cateringTimeClose: getCateringClose(),
      };
    }

    function getDhIsClosed() {
      if (dhIsClosed === 'Y') return 'Y';
      return 'N';
    }

    function getDeliveryTimeOpen() {
      if (!hasDeliveryPermission) return undefined;
      if (dhIsClosed === 'Y' && !RestaurantId) return '';
      if (
        dhIsClosed !== 'Y' &&
        isCalculated !== 'Y' &&
        deliveryTimeOpen &&
        times.includes(deliveryTimeOpen)
      )
        return deliveryTimeOpen;
      return undefined;
    }

    function getDeliveryTimeClose() {
      if (!hasDeliveryPermission) return undefined;
      if (dhIsClosed === 'Y' && !RestaurantId) return '';
      if (
        dhIsClosed !== 'Y' &&
        isCalculated !== 'Y' &&
        deliveryTimeClose &&
        times.includes(deliveryTimeClose)
      )
        return deliveryTimeClose;
      return undefined;
    }

    function getCurbsideOpen() {
      if (!(curbsideService && curbsideService.value)) return undefined;
      if (curbsideIsClosed === 'Y' && !RestaurantId) return '';
      if (
        curbsideIsClosed !== 'Y' &&
        curbsideTimeOpen &&
        times.includes(curbsideTimeOpen)
      )
        return curbsideTimeOpen;
      if (
        !curbsideTimeOpen &&
        RestaurantId &&
        ((!closeToAll && brand === 'TH') || brand !== 'TH')
      ) {
        throw new Error(i18next.t('operationHours.curbsideMandatory'));
      }
      return undefined;
    }

    function getCurbsideClose() {
      if (!(curbsideService && curbsideService.value)) return undefined;
      if (curbsideIsClosed === 'Y' && !RestaurantId) return '';
      if (
        curbsideIsClosed !== 'Y' &&
        curbsideTimeClose &&
        times.includes(curbsideTimeClose)
      )
        return curbsideTimeClose;
      if (
        !curbsideTimeClose &&
        RestaurantId &&
        ((!closeToAll && brand === 'TH') || brand !== 'TH')
      ) {
        throw new Error(i18next.t('operationHours.curbsideMandatory'));
      }
      return undefined;
    }

    function getCateringOpen() {
      if (!(cateringService && cateringService.value)) return undefined;
      if (cateringIsClosed === 'Y' && !RestaurantId) return '';
      if (
        cateringIsClosed !== 'Y' &&
        cateringTimeOpen &&
        times.includes(cateringTimeOpen)
      )
        return cateringTimeOpen;
      if (
        !cateringTimeOpen &&
        RestaurantId &&
        ((!closeToAll && brand === 'TH') || brand !== 'TH') &&
        isNotPLKLockedDayparts
      ) {
        throw new Error(i18next.t('operationHours.cateringMandatory'));
      }
      return undefined;
    }

    function getCateringClose() {
      if (!(cateringService && cateringService.value)) return undefined;
      if (cateringIsClosed === 'Y' && !RestaurantId) return '';
      if (
        cateringIsClosed !== 'Y' &&
        cateringTimeClose &&
        times.includes(cateringTimeClose)
      )
        return cateringTimeClose;
      if (
        !cateringTimeClose &&
        RestaurantId &&
        ((!closeToAll && brand === 'TH') || brand !== 'TH') &&
        isNotPLKLockedDayparts
      ) {
        throw new Error(i18next.t('operationHours.cateringMandatory'));
      }
      return undefined;
    }

    let finalData: any = {};
    if (RestaurantId) {
      finalData = requestBody;
    } else {
      const selectedRestaurants =
        getState().RestaurantsReducer.selectedRestaurantsList;
      const restaurants = selectedRestaurants.map(
        restaurant => restaurant.metas?.restaurantId,
      );
      requestBody.isCalculated = 'N';
      finalData = {
        data: requestBody,
        restaurants: restaurants,
      };
    }
    const val = useValidationHoursAndEmitMessage({
      body: requestBody,
      translation,
      dispatch,
    });

    if (!val) return val;

    return axiosAction.patch(
      endpoint,
      CREATE_SPECIAL_EVENT,
      dispatch,
      finalData,
    );
  };

export const uploadSpecialEventFile = finalData => async dispatch => {
  const endpoint = `${process.env.REACT_APP_ENDPOINT_SPECIAL_EVENT}/massUpload`;
  return axiosAction.patch(endpoint, CREATE_SPECIAL_EVENT, dispatch, finalData);
};

export const getSpecialEventsReasons = () => async dispatch => {
  const endpoint = `${process.env.REACT_APP_ENDPOINT_SPECIAL_EVENT_REASONS}`;
  return axiosAction.get(endpoint, GET_SPECIAL_EVENT_REASONS, dispatch);
};

export const getHealthCheckMDS = () => async dispatch => {
  const endpoint = `${process.env.REACT_APP_ENDPOINT_HEALTH_CHECK_MDS}`;
  return axiosAction.get(endpoint, HEALTH_CHECK_MDS, dispatch);
};

export const getDeliveryHours =
  (brand: string, countryId: number) => async dispatch => {
    const endpoint = `${process.env.REACT_APP_ENDPOINT_DELIVERY_HOURS}/${brand}?country=${countryId}`;
    return axiosAction.get(endpoint, GET_DELIVERY_HOURS, dispatch);
  };

export const getSingleRestaurantBaseWeekHours =
  ({ restaurantNumber, brand }: { restaurantNumber: number; brand: string }) =>
  async dispatch => {
    const endpoint = `${process.env.REACT_APP_ENDPOINT_RESTAURANT_BASE_HOURS}`;
    return axiosAction.post(
      endpoint,
      GET_SINGLE_RESTAURANT_WEEK_HOURS,
      dispatch,
      {
        restaurantNumbers: [restaurantNumber],
        brand,
      },
    );
  };

export const getSpecialEventDayByDay =
  ({ restaurantId, startDate, endDate }) =>
  async dispatch => {
    const endpoint = `${process.env.REACT_APP_ENDPOINT_SPECIAL_EVENT_DAY_BY_DAY}/${restaurantId}?start=${startDate}&end=${endDate}`;
    return axiosAction.get(endpoint, GET_SPECIAL_EVENT_DAY_BY_DAY, dispatch);
  };

export const showHolidays = (showHolidays: boolean) => ({
  type: SHOW_HOLIDAYS,
  payload: showHolidays,
});

export const clearForm = () => ({
  type: CLEAR_FORM,
});

export const setSpecialEventData = (specialEvent: Record<string, any>) => ({
  type: SET_SPECIAL_EVENT_DATA,
  payload: specialEvent,
});

export const setSpecificSpecialEventData = (
  specialEvent: Record<string, any>,
) => ({
  type: SET_SPECIFIC_SPECIAL_EVENT_DATA,
  payload: specialEvent,
});

export const setCloseToAll = (close: boolean) => {
  let payload = {};

  if (close) {
    payload = {
      open24Hours: false,
      closeToAll: true,

      cateringIsClosed: 'Y',

      curbsideIsClosed: 'Y',

      drIsOpened24Hours: 'N',
      drIsClosed: 'Y',
      drTimeOpen: '',
      drTimeClose: '',

      dtIsOpened24Hours: 'N',
      dtIsClosed: 'Y',
      dtTimeOpen: '',
      dtTimeClose: '',

      digitalDtIsOpened24Hours: 'N',
      digitalDtIsClosed: 'Y',
      digitalDtTimeOpen: '',
      digitalDtTimeClose: '',

      dhIsClosed: 'Y',
      deliveryTimeOpen: '',
      deliveryTimeClose: '',
    };
  } else {
    payload = {
      cateringIsClosed: 'N',

      curbsideIsClosed: 'N',
      dhIsClosed: 'N',
      drIsClosed: 'N',
      dtIsClosed: 'N',
      digitalDtIsClosed: 'N',
      open24Hours: false,
      closeToAll: false,
    };
  }

  return {
    type: SET_CLOSE_TO_ALL,
    payload: payload,
  };
};

export const setOpen24HoursToAll = (open: boolean, isCalculated: string) => {
  let delivery = {};
  let payload = {};

  if (open) {
    if (isCalculated === 'Y') {
      delivery = {
        deliveryTimeOpen: '00:00',
        deliveryTimeClose: '23:59',
      };
    }

    payload = {
      open24Hours: true,
      closeToAll: false,
      drIsOpened24Hours: 'Y',
      drIsClosed: 'N',
      drTimeOpen: '00:00',
      drTimeClose: '23:59',

      dtIsOpened24Hours: 'Y',
      dtIsClosed: 'N',
      dtTimeOpen: '00:00',
      dtTimeClose: '23:59',

      digitalDtIsOpened24Hours: 'Y',
      digitalDtIsClosed: 'N',
      digitalDtTimeOpen: '00:00',
      digitalDtTimeClose: '23:59',

      ...delivery,
    };
  } else {
    payload = {
      open24Hours: false,
      closeToAll: false,
      drIsOpened24Hours: 'N',
      dtIsOpened24Hours: 'N',
      digitalDtIsOpened24Hours: 'N',
    };
  }

  return {
    type: SET_OPEN_24HOURS_TO_ALL,
    payload: payload,
  };
};

export const startRange = RestaurantId => async (dispatch, getState) => {
  dispatch({ type: SET_IS_LOADING.REQUEST });

  dispatch({
    type: CLEAR_TIMETABLE,
  });

  const today = moment().startOf('day');
  const dailyHoursResponse = await getDailyHours(
    RestaurantId,
    getWeekDay(today),
  );

  const permissions = {
    drTimeOpenMode: dailyHoursResponse.drTimeOpenMode,
    drTimeCloseMode: dailyHoursResponse.drTimeCloseMode,
    drIsOpened24HoursMode: dailyHoursResponse.drIsOpened24HoursMode,
    dtTimeOpenMode: dailyHoursResponse.dtTimeOpenMode,
    dtTimeCloseMode: dailyHoursResponse.dtTimeCloseMode,
    dtIsClosedMode: dailyHoursResponse.dtIsClosedMode,
    dtIsOpened24HoursMode: dailyHoursResponse.dtIsOpened24HoursMode,
    digitalDtTimeOpenMode: dailyHoursResponse.digitalDtTimeOpenMode,
    digitalDtTimeCloseMode: dailyHoursResponse.digitalDtTimeCloseMode,
    digitalDtIsClosedMode: dailyHoursResponse.digitalDtIsClosedMode,
    digitalDtIsOpened24HoursMode:
      dailyHoursResponse.digitalDtIsOpened24HoursMode,
    deliveryTimeOpenMode: dailyHoursResponse.deliveryTimeOpenMode,
    deliveryTimeCloseMode: dailyHoursResponse.deliveryTimeCloseMode,
    curbsideTimeOpenMode: dailyHoursResponse.curbsideTimeOpenMode,
    curbsideTimeCloseMode: dailyHoursResponse.curbsideTimeCloseMode,
    cateringTimeOpenMode: dailyHoursResponse.cateringTimeOpenMode,
    cateringTimeCloseMode: dailyHoursResponse.cateringTimeCloseMode,
    cateringIsClosedMode: dailyHoursResponse.cateringIsClosedMode,
    dhIsClosedMode: dailyHoursResponse.dhIsClosedMode,
    curbsideIsClosedMode: dailyHoursResponse.curbsideIsClosedMode,
  };

  dispatch(
    setSpecialEventData({
      isCalculated: dailyHoursResponse.isCalculated,
      ...permissions,
    }),
  );

  dispatch({ type: SET_IS_LOADING.SUCCESS });
};

export const setSelectedRangeDate =
  (startDate: Moment, endDate: Moment) => async (dispatch, getState) => {
    dispatch({ type: SET_IS_LOADING.REQUEST });

    dispatch({
      type: CLEAR_TIMETABLE,
    });

    dispatch({
      type: SET_SELECTED_RANGE_DATE,
      payload: {
        selectedStartDate: startDate,
        selectedEndDate: endDate,
      },
    });

    const { RestaurantId } = getState().RestaurantsReducer.entity;
    if (!RestaurantId) {
      dispatch({ type: SET_IS_LOADING.SUCCESS });
      return true;
    }
    const weekDaysSelected: Array<string> = [];
    for (let i: Moment = moment(startDate); i.isSameOrBefore(endDate); ) {
      const weekDay = i.format('d');

      if (!weekDaysSelected.includes(weekDay)) {
        weekDaysSelected.push(weekDay);
      }

      if (weekDaysSelected.length >= 7) {
        break;
      }

      i.add(1, 'days');
    }
    let response = await getSpecialEvent(
      RestaurantId,
      startDate,
      endDate,
      true,
    );
    const [
      dailyHoursResponseSunday,
      dailyHoursResponseMonday,
      dailyHoursResponseTuesday,
      dailyHoursResponseWednesday,
      dailyHoursResponseThursday,
      dailyHoursResponseFriday,
      dailyHoursResponseSaturday,
    ] = await Promise.all([
      getDailyHours(RestaurantId, '1 - Sunday'),
      getDailyHours(RestaurantId, '2 - Monday'),
      getDailyHours(RestaurantId, '3 - Tuesday'),
      getDailyHours(RestaurantId, '4 - Wednesday'),
      getDailyHours(RestaurantId, '5 - Thursday'),
      getDailyHours(RestaurantId, '6 - Friday'),
      getDailyHours(RestaurantId, '7 - Saturday'),
    ]);

    const isCalculated =
      (dailyHoursResponseSunday.isCalculated == 'Y' &&
        weekDaysSelected.includes('0')) ||
      (dailyHoursResponseMonday.isCalculated == 'Y' &&
        weekDaysSelected.includes('1')) ||
      (dailyHoursResponseTuesday.isCalculated == 'Y' &&
        weekDaysSelected.includes('2')) ||
      (dailyHoursResponseWednesday.isCalculated == 'Y' &&
        weekDaysSelected.includes('3')) ||
      (dailyHoursResponseThursday.isCalculated == 'Y' &&
        weekDaysSelected.includes('4')) ||
      (dailyHoursResponseFriday.isCalculated == 'Y' &&
        weekDaysSelected.includes('5')) ||
      (dailyHoursResponseSaturday.isCalculated == 'Y' &&
        weekDaysSelected.includes('6'))
        ? 'Y'
        : 'N';

    const permissions = {
      drTimeOpenMode: dailyHoursResponseMonday.drTimeOpenMode,
      drTimeCloseMode: dailyHoursResponseMonday.drTimeCloseMode,
      drIsOpened24HoursMode: dailyHoursResponseMonday.drIsOpened24HoursMode,
      dtTimeOpenMode: dailyHoursResponseMonday.dtTimeOpenMode,
      dtTimeCloseMode: dailyHoursResponseMonday.dtTimeCloseMode,
      dtIsClosedMode: dailyHoursResponseMonday.dtIsClosedMode,
      dtIsOpened24HoursMode: dailyHoursResponseMonday.dtIsOpened24HoursMode,
      digitalDtTimeOpenMode: dailyHoursResponseMonday.digitalDtTimeOpenMode,
      digitalDtTimeCloseMode: dailyHoursResponseMonday.digitalDtTimeCloseMode,
      digitalDtIsClosedMode: dailyHoursResponseMonday.digitalDtIsClosedMode,
      digitalDtIsOpened24HoursMode:
        dailyHoursResponseMonday.digitalDtIsOpened24HoursMode,
      deliveryTimeOpenMode: dailyHoursResponseMonday.deliveryTimeOpenMode,
      deliveryTimeCloseMode: dailyHoursResponseMonday.deliveryTimeCloseMode,
      curbsideTimeOpenMode: dailyHoursResponseMonday.curbsideTimeOpenMode,
      curbsideTimeCloseMode: dailyHoursResponseMonday.curbsideTimeCloseMode,
      cateringTimeOpenMode: dailyHoursResponseMonday.cateringTimeOpenMode,
      cateringTimeCloseMode: dailyHoursResponseMonday.cateringTimeCloseMode,
      cateringIsClosedMode: dailyHoursResponseMonday.cateringIsClosedMode,
      dhIsClosedMode: dailyHoursResponseMonday.dhIsClosedMode,
      curbsideIsClosedMode: dailyHoursResponseMonday.curbsideIsClosedMode,
    };

    if (response) {
      response = sanitizeResponse(response);
      // Get Specific Range Date
      const rangeResponse = response.find(elem => {
        const startD = moment(elem.specialEventDateStart, formatYYYYMMDD);
        const endD = moment(elem.specialEventDateEnd, formatYYYYMMDD);

        return startD.isSame(startDate) && endD.isSame(endDate);
      });

      // If there is a specific range we show it.
      if (rangeResponse) {
        dispatch(
          setSpecialEventData({
            isCalculated: isCalculated,
            ...rangeResponse,
            ...permissions,
          }),
        );
      }
      // We loop to response
      else {
        const sortedResponse = response.sort((first, two) => {
          const firstStartD = moment(
            first.specialEventDateStart,
            formatYYYYMMDD,
          );
          const twoStartD = moment(two.specialEventDateStart, formatYYYYMMDD);
          if (firstStartD.isBefore(twoStartD)) {
            return -1;
          } else if (firstStartD.isAfter(twoStartD)) {
            return 1;
          }
          return 0;
        });

        let dateToShow: any = null;

        for (let i = moment(startDate); i.isSameOrBefore(endDate); ) {
          const rangeResponse = sortedResponse.find(elem => {
            const startD = moment(elem.specialEventDateStart, formatYYYYMMDD);
            const endD = moment(elem.specialEventDateEnd, formatYYYYMMDD);

            return i.isSameOrAfter(startD) && i.isSameOrBefore(endD);
          });

          if (rangeResponse) {
            if (dateToShow) {
              // If events are equals we continue

              const obj1 = { ...dateToShow };
              const obj2 = { ...rangeResponse };

              delete obj1.id;
              delete obj1.specialEventReason;
              delete obj1.specialEventDateStart;
              delete obj1.specialEventDateEnd;
              delete obj2.id;
              delete obj2.specialEventReason;
              delete obj2.specialEventDateStart;
              delete obj2.specialEventDateEnd;

              if (
                Object.entries(obj1).toString() ===
                Object.entries(obj2).toString()
              ) {
                dateToShow = rangeResponse;
              } else {
                dateToShow = null;
                break;
              }
            } else {
              dateToShow = rangeResponse;
            }

            i = moment(rangeResponse.specialEventDateEnd, formatYYYYMMDD);
            i.add(1, 'days');
          } else {
            dateToShow = null;
            break;
          }
        }

        if (dateToShow) {
          dispatch(
            setSpecialEventData({
              isCalculated: isCalculated,
              ...dateToShow,
              specialEventDateStart: startDate.format(formatYYYYMMDD),
              specialEventDateEnd: endDate.format(formatYYYYMMDD),
              ...permissions,
            }),
          );
        } else {
          dispatch(
            setSpecialEventData({ isCalculated: isCalculated, ...permissions }),
          );
        }
      }
    } else {
      dispatch(
        setSpecialEventData({ isCalculated: isCalculated, ...permissions }),
      );
    }

    dispatch({ type: SET_IS_LOADING.SUCCESS });
  };

export const setSelectedStartDate =
  (date: Moment) => async (dispatch, getState) => {
    dispatch({ type: SET_IS_LOADING.REQUEST });

    dispatch({
      type: CLEAR_TIMETABLE,
    });

    dispatch({
      type: SET_SELECTED_START_DATE,
      payload: date,
    });

    const { RestaurantId } = getState().RestaurantsReducer.entity;
    const holidays = getState().HolidaysReducer.holidays;

    if (!RestaurantId) {
      dispatch({ type: SET_IS_LOADING.SUCCESS });
      return true;
    }

    // First we check if there is a special event in the date
    // We get the permisisons and base hours
    let response = await getSpecialEvent(RestaurantId, date, date);
    const dailyHoursResponse = await getDailyHours(
      RestaurantId,
      getWeekDay(date),
    );

    const permissions = {
      drTimeOpenMode: dailyHoursResponse.drTimeOpenMode,
      drTimeCloseMode: dailyHoursResponse.drTimeCloseMode,
      drIsOpened24HoursMode: dailyHoursResponse.drIsOpened24HoursMode,
      dtTimeOpenMode: dailyHoursResponse.dtTimeOpenMode,
      dtTimeCloseMode: dailyHoursResponse.dtTimeCloseMode,
      dtIsClosedMode: dailyHoursResponse.dtIsClosedMode,
      dtIsOpened24HoursMode: dailyHoursResponse.dtIsOpened24HoursMode,
      digitalDtTimeOpenMode: dailyHoursResponse.digitalDtTimeOpenMode,
      digitalDtTimeCloseMode: dailyHoursResponse.digitalDtTimeCloseMode,
      digitalDtIsClosedMode: dailyHoursResponse.digitalDtIsClosedMode,
      digitalDtIsOpened24HoursMode:
        dailyHoursResponse.digitalDtIsOpened24HoursMode,
      deliveryTimeOpenMode: dailyHoursResponse.deliveryTimeOpenMode,
      deliveryTimeCloseMode: dailyHoursResponse.deliveryTimeCloseMode,
      curbsideTimeOpenMode: dailyHoursResponse.curbsideTimeOpenMode,
      curbsideTimeCloseMode: dailyHoursResponse.curbsideTimeCloseMode,
      cateringTimeOpenMode: dailyHoursResponse.cateringTimeOpenMode,
      cateringTimeCloseMode: dailyHoursResponse.cateringTimeCloseMode,
      cateringIsClosedMode: dailyHoursResponse.cateringIsClosedMode,
      dhIsClosedMode: dailyHoursResponse.dhIsClosedMode,
      curbsideIsClosedMode: dailyHoursResponse.curbsideIsClosedMode,
    };

    const otherTimes = {
      isCalculated: dailyHoursResponse.isCalculated,
      breakfastTimeOpen: dailyHoursResponse.breakfastTimeOpen,
      breakfastTimeClose: dailyHoursResponse.breakfastTimeClose,
      lunchTimeOpen: dailyHoursResponse.lunchTimeOpen,
      lunchTimeClose: dailyHoursResponse.lunchTimeClose,
      snackTimeOpen: dailyHoursResponse.snackTimeOpen,
      snackTimeClose: dailyHoursResponse.snackTimeClose,
      dinnerTimeOpen: dailyHoursResponse.dinnerTimeOpen,
      dinnerTimeClose: dailyHoursResponse.dinnerTimeClose,
      lateNightTimeOpen: dailyHoursResponse.lateNightTimeOpen,
      lateNightTimeClose: dailyHoursResponse.lateNightTimeClose,
    };

    response = sanitizeResponse(response);

    if (response) {
      dispatch(
        setSpecialEventData({ ...otherTimes, ...response, ...permissions }),
      );
    } else if (Array.isArray(holidays) && holidays.length) {
      // If no special day we check if there is a special holiday
      const specialHoliday = holidays.reduce((acc, holiday) => {
        const holidayDate = moment(holiday.date).startOf('day');
        if (holidayDate.isSame(date)) {
          return holiday;
        } else {
          return acc;
        }
      }, null);

      if (specialHoliday) {
        response = await getSpecialHoliday(RestaurantId, specialHoliday.id);
        if (response) {
          dispatch(
            setSpecialEventData({
              ...otherTimes,
              specialEventDateStart: date.format(formatYYYYMMDD),
              specialEventDateEnd: date.format(formatYYYYMMDD),
              drIsOpened24Hours: response?.hdrIsOpened24Hours,
              drIsClosed: response?.hdrIsClosed,
              drTimeOpen: response?.hdrTimeOpen,
              drTimeClose: response?.hdrTimeClose,
              dtIsOpened24Hours: response?.hdtIsOpened24Hours,
              dtIsClosed: response?.hdtIsClosed,
              dtTimeOpen: response?.hdtTimeOpen,
              dtTimeClose: response?.hdtTimeClose,
              deliveryTimeOpen: response?.hdeliveryTimeOpen,
              deliveryTimeClose: response?.hdeliveryTimeClose,
              curbsideTimeOpen: response?.hcurbsideTimeOpen,
              curbsideTimeClose: response?.hcurbsideTimeClose,
              isCalculated: response?.hisCalculated,
              cateringIsClosed: response?.cateringIsClosed,
              curbsideIsClosed: response?.curbsideIsClosed,
              dhIsClosed: response?.dhIsClosed,
              ...permissions,
            }),
          );
        } else {
          if (dailyHoursResponse) {
            dispatch(
              setSpecialEventData({
                ...dailyHoursResponse,
                arrivalTime: dailyHoursResponse.arrivalTime,
                departureTime: dailyHoursResponse.departureTime,
              }),
            );
          }
        }
      } else {
        if (dailyHoursResponse) {
          dispatch(
            setSpecialEventData({
              ...dailyHoursResponse,
              arrivalTime: dailyHoursResponse.arrivalTime,
              departureTime: dailyHoursResponse.departureTime,
            }),
          );
        }
      }
      // We set the base calendar options as defualt
    } else {
      if (dailyHoursResponse) {
        dispatch(
          setSpecialEventData({
            ...dailyHoursResponse,
            arrivalTime: dailyHoursResponse.arrivalTime,
            departureTime: dailyHoursResponse.departureTime,
          }),
        );
      }
    }

    dispatch({ type: SET_IS_LOADING.SUCCESS });
  };

async function getSpecialEvent(
  restaurantId: number,
  startDate: Moment,
  endDate: Moment,
  all = false,
) {
  const specialEventEndpoint = `${process.env.REACT_APP_ENDPOINT_SPECIAL_EVENT}`;
  const { data } = await axios(
    `${specialEventEndpoint}/${restaurantId}?start=${startDate.format(
      formatYYYYMMDD,
    )}&end=${endDate.format(formatYYYYMMDD)}`,
  );

  if (all && data.length >= 1) {
    return data;
  } else if (all) {
    return null;
  }

  if (data.length === 1) {
    return data[0];
  } else if (data.length > 1) {
    return data[data.length - 1];
  } else {
    return null;
  }
}

async function getSpecialHoliday(restaurantId: number, holiday: number) {
  const holidaysHourEndpoint = `${process.env.REACT_APP_ENDPOINT_HOLIDAYS_HOUR_ENDPOINT}`;
  const { data } = await axios(
    `${holidaysHourEndpoint}/${restaurantId}?holiday=${holiday}`,
  );

  if (data.length === 1) {
    return data[0];
  } else if (data.length > 1) {
    return data[data.length - 1];
  } else {
    return null;
  }
}

async function getDailyHours(restaurantId: number, weekDay: string) {
  const dailyHoursEndpoint = `${process.env.REACT_APP_ENDPOINT_OPERATION_HOURS}`;
  const { data } = await axios(
    `${dailyHoursEndpoint}/${restaurantId}?weekDay=${weekDay}&setting=base`,
  );

  return data;
}

function getWeekDay(date: Moment) {
  const weekDay = date.format('d');

  const weekDays = {
    '0': '1 - Sunday',
    '1': '2 - Monday',
    '2': '3 - Tuesday',
    '3': '4 - Wednesday',
    '4': '5 - Thursday',
    '5': '6 - Friday',
    '6': '7 - Saturday',
  };

  return weekDays[weekDay];
}

function sanitizeResponse(response) {
  if (response) {
    if (response.dtIsOpened24Hours && response.dtIsOpened24Hours === 'N') {
      if (response.dtTimeOpen && !times.includes(response.dtTimeOpen)) {
        response.dtTimeOpen = null;
      }
      if (response.dtTimeClose && !times.includes(response.dtTimeClose)) {
        response.dtTimeClose = null;
      }
    }

    if (
      response.digitalDtIsOpened24Hours &&
      response.digitalDtIsOpened24Hours === 'N'
    ) {
      if (
        response.digitalDtTimeOpen &&
        !times.includes(response.digitalDtTimeOpen)
      ) {
        response.digitalDtTimeOpen = null;
      }
      if (
        response.digitalDtTimeClose &&
        !times.includes(response.digitalDtTimeClose)
      ) {
        response.digitalDtTimeClose = null;
      }
    }

    if (response.drIsOpened24Hours && response.drIsOpened24Hours === 'N') {
      if (response.drTimeOpen && !times.includes(response.drTimeOpen)) {
        response.drTimeOpen = null;
      }
      if (response.drTimeClose && !times.includes(response.drTimeClose)) {
        response.drTimeClose = null;
      }
    }
  }
  return response;
}

export const setSpecialEventRestaurantsPermissions =
  permissions => async (dispatch, getState) => {
    dispatch(setSpecialEventData(permissions));
  };

export const getMassUploadExcelFile =
  (brand: string, type: string, lang: string, filename: string): any =>
  async dispatch => {
    const endpoint = `${process.env.REACT_APP_ENDPOINT_EXCEL_URL}`;
    return axiosAction.get(endpoint, GET_MASS_UPLOAD_FILE, dispatch, {
      meta: {
        brand,
      },
      params: {
        brand,
        type,
        lang,
        filename,
      },
    });
  };

export const toggleOperationHoursViewMode = (shouldSwitch = true) => ({
  type: TOGGLE_OPERATION_HOURS_VIEW_MODE,
  payload: shouldSwitch,
});

export const setRecentlyEditedBaseHours = (
  recentlyEditedBaseHours: RecentlyEditedBaseHours,
) => ({
  type: SET_RECENTLY_EDITED_BASE_HOURS,
  payload: recentlyEditedBaseHours,
});

export const clearRecentlyEditedBaseHours = () => ({
  type: CLEAR_RECENTLY_EDITED_BASE_HOURS,
});
